import Vue from "vue"
import Buefy from "buefy"
import PublicNav from "./App.vue"

Vue.use(Buefy, {
    defaultIconPack: 'fas',
})

Vue.use(PublicNav)

if(document.getElementById("publicNav")){
    new Vue({
        render: h=>h(PublicNav,{
            props:{
                primaryColor:document.getElementById("publicNav")
                    .getAttribute("primary-color"),
                logo:document.getElementById("publicNav")
                    .getAttribute("logo"),
                categoriesUrl:document.getElementById("publicNav")
                    .getAttribute("categories"),
                blackText:document.getElementById("publicNav")
                    .getAttribute("black-text"),
                cartDetail:document.getElementById("publicNav")
                    .getAttribute("cartDetail"),
                cartCount:document.getElementById("publicNav")
                    .getAttribute("cartCount"),
                userIn:document.getElementById("publicNav")
                    .getAttribute("userIn"),
                logoutUrl:document.getElementById("publicNav")
                    .getAttribute("logout-url"),
                loginUrl:document.getElementById("publicNav")
                    .getAttribute("login-url"),
                registerUrl:document.getElementById("publicNav")
                    .getAttribute("register-url"),
                userSettings: document.getElementById("publicNav")
                    .getAttribute("user-settings"),
                userEmailActive: document.getElementById("publicNav")
                    .getAttribute("user-email-active"),
                searchEndpoint: document.getElementById("publicNav")
                    .getAttribute("search-endpoint"),
                searchResultsUrl: document.getElementById("publicNav")
                    .getAttribute("search-results-url"),
                contactUrl: document.getElementById("publicNav")
                    .getAttribute("contact-url"),
                isStore: document.getElementById("publicNav")
                    .getAttribute("is-store"),
                isContent: document.getElementById("publicNav")
                    .getAttribute("is-content"),
                isFullSite: document.getElementById("publicNav")
                    .getAttribute("is-full-site"),
                isB2b: document.getElementById("publicNav")
                    .getAttribute("is-b2b"),
                pedidosUrl: document.getElementById("publicNav")
                    .getAttribute("pedidos-url"),
                profileStreet: document.getElementById("publicNav")
                    .getAttribute("profile-street"),
                profileRegion: document.getElementById("publicNav")
                    .getAttribute("profile-region"),
                faqsFlag: document.getElementById("publicNav")
                    .getAttribute("faqs-flag"),
                faqsUrl: document.getElementById("publicNav")
                    .getAttribute("faqs-url"),
                blogUrl: document.getElementById("publicNav")
                    .getAttribute("blog-url"),
                blogFlag: document.getElementById("publicNav")
                    .getAttribute("blog-flag"),
                blogPowerUp: document.getElementById("publicNav")
                    .getAttribute("blog-powerup"),
                pageListUrl: document.getElementById("publicNav")
                    .getAttribute("pages-list-url"),
                generalCatalogUrl: document.getElementById("publicNav")
                .getAttribute("generalCatalogUrl"),
            }
        })
    }).$mount("#publicNav")
}